<script lang="ts">
    import {Link} from 'svelte-routing'
    import {onDestroy, onMount} from 'svelte'
    import arrow from 'src/components/main/home/components/event/arrow.svg'

    let firstLink = 'https://realis.network/blog/crypto-pepe-mobile-game-launch'
    let firstEventText = 'Crypto Frepe'
    let firstStartDate = new Date(Date.UTC(2024, 7, 20, 14, 0))
    let startDateInMls = firstStartDate.getTime()

    let secondLink = 'https://realis.network/blog/elon-musk-crypto-mobile-game-launch'
    let secondEventText = 'Elon Game'
    let secondPublishDate = new Date(Date.UTC(2023, 9, 12, 19, 0))
    let secondPublishDateInMls = secondPublishDate.getTime()
    let secondStartDate = new Date(Date.UTC(2024, 1, 26, 12, 0))
    let secondDateInMls = secondStartDate.getTime()

    let nowDate = new Date().getTime()

    let firstDays = 0
    let firstHours = 0
    let firstMinutes = 0
    let firstSeconds = 0
    let firstTimerInterval

    let secondDays = 0
    let secondHours = 0
    let secondMinutes = 0
    let secondSeconds = 0
    let secondTimerInterval

    function startTimerFirst() {
        const targetTime = new Date(firstStartDate).getTime()

        firstTimerInterval = setInterval(() => {
            const now = new Date().getTime()
            const timeRemaining = targetTime - now

            firstDays = Math.floor(timeRemaining / (1000 * 60 * 60 * 24))
            firstHours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            firstMinutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))
            firstSeconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)

            if (timeRemaining <= 0) {
                clearInterval(firstTimerInterval)
            }
        }, 1000)
    }

    function startTimerSecond() {
        const targetTime = new Date(secondStartDate).getTime()

        secondTimerInterval = setInterval(() => {
            const now = new Date().getTime()
            const timeRemaining = targetTime - now

            secondDays = Math.floor(timeRemaining / (1000 * 60 * 60 * 24))
            secondHours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            secondMinutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))
            secondSeconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)

            if (timeRemaining <= 0) {
                clearInterval(secondTimerInterval)
            }
        }, 1000)
    }

    onMount(() => {
        startTimerFirst()
        startTimerSecond()
    })

    onDestroy(() => {
        clearInterval(firstTimerInterval)
        clearInterval(secondTimerInterval)
    })
</script>

<div class="event-line">
    <a href="{firstLink}" class:active-event-link={firstLink.startsWith('http')}>
        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="event-text">
                        {#if startDateInMls > nowDate}
                            {firstEventText} launch in
                        {:else}
                            {firstEventText} launched
                        {/if}
                    </div>
                    <!--<img src={arrow} class="arrow" alt="arrow">-->
                </div>
                {#if startDateInMls > nowDate}
                    <div class="col timer">
                        {#if firstDays > 0}<span>{firstDays}</span>d{/if}
                        {#if firstHours > 0}<span>{firstHours}</span>h{/if}
                        {#if firstMinutes > 0}<span>{firstMinutes}</span>m{/if}
                        {#if firstSeconds > 0}<span>{firstSeconds}</span>s{/if}
                    </div>
                {/if}
            </div>
        </div>
    </a>
    <!--
    {#if nowDate > secondPublishDateInMls}
        <a href="{secondLink}" class:active-event-link={secondLink.startsWith('http')} class="second-line">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="event-text">
                            {#if secondDateInMls > nowDate}
                                {secondEventText} launch in
                            {:else}
                                {secondEventText} launched
                            {/if}
                        </div>
                    </div>
                    {#if secondDateInMls > nowDate}
                        <div class="col timer">
                            {#if secondDays > 0}<span>{secondDays}</span>d{/if}
                            {#if secondHours > 0}<span>{secondHours}</span>h{/if}
                            {#if secondMinutes > 0}<span>{secondMinutes}</span>m{/if}
                            {#if secondSeconds > 0}<span>{secondSeconds}</span>s{/if}
                        </div>
                    {/if}
                </div>
            </div>
        </a>
    {/if}
    -->
</div>

<style>
    .event-line {
        width: 1364px;
        border-radius: 0 0 8px 8px;
        color: white;
        background: #FE5D1D;
        left: 50%;
        top: 130px;
        transform: translate(-50%, 0);
        position: fixed;
        z-index: 4;
    }

    .second-line {
        background: #944ead;
        border-radius: 0 0 8px 8px;
    }

    .event-line :global(a) {
        color: white;
        text-decoration: none;
        font-size: 16px;
        font-weight: 500;
        display: block;
        padding: 10px 0;
    }

    .timer {
        text-align: right;
    }

    .row {
        justify-content: center;
        align-items: center;
    }

    .col {
        flex: 0 0 auto;
        width: auto;
    }

    .active-event-link .event-text {
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    }

    .event-text {
        text-align: center;
    }

    .arrow {
        width: 14px;
        margin: 0 0 0 -3px;
    }

    @media (max-width: 1550px) {
        .event-line {
            width: 1340px;
        }
    }

    @media (max-width: 1400px) {
        .event-line {
            width: 1200px;
        }
    }

    @media (max-width: 1200px) {
        .event-line {
            width: 960px;
        }
    }

    @media (max-width: 991px) {
        .event-line {
            top: 70px;
            font-size: 15px;
            width: 100%;
            border-radius: 0;
        }

        .event-line a {
            font-size: 15px;
            padding: 8px 0;
        }

        .second-line {
            border-radius: 0;
        }
    }

    @media(max-width: 767px) {
        .event-text {
            font-size: 13px;
            border-color: transparent;
            display: table;
            margin: 0 auto 3px;
        }

        .event-line {
            width: 100%;
            margin: 0;
            top: 62px;
            position: fixed;
        }

        .event-line :global(a) {
            font-size: 14px;
        }

        .col {
            flex: auto;
        }

        .timer {
            text-align: center;
            font-size: 13px;
        }

        .timer span {
            font-size: 15px;
        }
    }
</style>
